
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.822 11.294c-.089-.1-.186-.173-.277-.27a1.63 1.63 0 01-.239-.318c-.475-.825-.5-1.94-.158-2.814.266-.678 1.35-2.606 1.904-2.639-.405.817-.911 1.895-.57 2.9.136.403.456.894.833 1.007.531.158 1.008-.304.915-.833.247.076.716.814.769 1.352.032.33-.04.645-.164.905-.133.277-.292.413-.467.597.705-.177 1.517-.917 1.914-1.545.155-.245.274-.497.369-.793.21-.649.19-1.346.03-2.006-.087-.357-.496-1.452-.715-1.613.226.993-.752 1.407-1.318.982-.697-.524-.148-1.09-.065-2.064A3.363 3.363 0 006.398 1.26c-.183-.155-.534-.46-.802-.555.035.71-.078 1.091-.386 1.644-.27.486-.542.867-.854 1.25-.363.448-.695.75-.995 1.11-1.025 1.237-1.68 3.194-.9 4.743.171.338.528.8.816 1.023.35.272 1.03.745 1.545.818z","fill":"#FF506F"}})])
          )
        }
      }
    